import React from 'react';

// Import Swiper styles
import "swiper/css";
import "swiper/css/navigation";

import './services.css';
import symbol from '../../assets/Washing-Rules-Symbols.png';

// Import Swiper React components
import { Swiper, SwiperSlide } from "swiper/react";


// import required modules
import { Navigation } from "swiper";

import { Feature } from '../../components';

// Create "Features" data array
const featuresData_1 = [
  {
    title: 'Cuci Pakaian Harian',
    text: 'Kaos & Celana berbahan campuran katun'
  },
  {
    title: 'Cuci Seragam Kerja',
    text: 'Kemeja, Almamater, Batik, PDL, dll.'
  },
  {
    title: 'Cuci Atasan Outer',
    text: 'Sweater, Jaket, Cardigan, dll.'
  },
  {
    title: 'Cuci Celana Outer',
    text: 'Jeans, Kargo, dll.'
  },
]

const featuresData_2 = [
  {
    title: 'Cuci Bahan Industrial',
    text: 'Karpet, Tirai, Latex, Carbon, dll.'
  },
  {
    title: 'Cuci Alas Tidur',
    text: 'Bed Cover, Selimut, Sprei, dll.'
  },
  {
    title: 'Cuci Sepatu & Tas',
    text: 'Tas berbahan Fabric & Kulit Sintetis'
  },
  {
    title: 'Cuci Spesial Request',
    text: 'Cucian dengan perawatan khusus*'
  },
]

const Services = () => {
  return (
    <div className="pl__services section__padding" id="layanan">
      <div className="pl__services-heading">
        <h1 className="gradient__text">Extra Bersih,<br />Wangi Ngga Lebay,<br />Jadi Lebih Tenang.</h1>
        <p>Pantja Laundry secara profesional menangani dengan baik cucian Anda dengan berusaha mengikuti aturan & saran mencuci pabrikan.</p>
        <img src={symbol} alt="Pantja Laundry Washing Rules" />
      </div>
      <div className="pl__services-container sm">
        <Swiper navigation={true} modules={[Navigation]} className="mySwiper">
          <SwiperSlide>
            {featuresData_1.map((item, index) => (
              <Feature title={item.title} text={item.text} key={item.title + index} />
            ))}
          </SwiperSlide>
          <SwiperSlide>
            {featuresData_2.map((item, index) => (
              <Feature title={item.title} text={item.text} key={item.title + index} />
            ))}
          </SwiperSlide>
        </Swiper>
      </div>
      <div className='pl__services-column lg'>
        <div className="pl__services-container">
          {featuresData_1.map((item, index) => (
            <Feature title={item.title} text={item.text} key={item.title + index} />
          ))}
        </div>
        <div className="pl__services-container">
          {featuresData_2.map((item, index) => (
            <Feature title={item.title} text={item.text} key={item.title + index} />
          ))}
        </div>
      </div>
    </div>
  )
}

export default Services